module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/furniture_quantities/size-3-19fea2c712f0dc6938b4528e825ecadf.svg";